module.exports = __webpack_public_path__ + "static/media/Badge_SvgSiteConnecte_Silver.931073e2.svg";